module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "destroy-user-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(1), _c('div', {
    staticClass: "user-identification"
  }, [_vm._v(" " + _vm._s(_vm.user.name) + "\n(" + _vm._s(_vm.user.email) + ")")]), _c('p'), _c('br'), _vm._m(2), _c('br'), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('replace_user_id')
    }
  }, [_c('label', [_vm._v("Usuário que receberá as responsabilidades do usuário excluído:")]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ("required"),
      expression: "\"required\""
    }],
    staticClass: "field",
    attrs: {
      "data-vv-name": "replace_user_id",
      "options": _vm.user_options,
      "selected": _vm.replace_user_id
    },
    model: {
      value: (_vm.replace_user_id),
      callback: function($$v) {
        _vm.replace_user_id = $$v
      },
      expression: "replace_user_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('replace_user_id')),
      expression: "errors.has('replace_user_id')"
    }],
    key: "replace_user_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('replace_user_id')))])])], 1)]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroyUser
    }
  }, [_vm._v("Excluir usuário")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Excluir usuário"), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Você está prestes a excluir o usuário:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Ao excluir um usuário, acontecerá o seguinte com suas responsabilidades no Reev:")]), _c('ul', [_c('li', [_vm._v("Seus fluxos serão pausados e excluídos.")]), _c('li', [_vm._v("As respostas dos fluxos serão redirecionadas para outro usuário.")]), _c('li', [_vm._v("Seus templates e contatos serão transferidos para outro usuário.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4df379f6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/destroy_modal.vue
// module id = 1110
// module chunks = 1